import React, { Component } from "react";
import BreadCrumbOwn from "./BreadCrumbOwn";
import { Grid, Container, Typography } from "@material-ui/core";
import { PostData } from "../../api/service";


export default class CommonTextPattern extends Component {
  state = {
    data: "",
    isLoaded: false,
  };

  componentDidMount() {
    let d = {
      dept_code: "NSS",
      type: this.props.type,
    };

    PostData(`/getnoticesbytypedept`, d).then((resp) => {
      if (resp.length > 0) {
        this.setState({
          data: resp[0],
          isLoaded: true,
        });
      }
    });
  }
  render() {
    return (
      <div>
        <BreadCrumbOwn title={this.props.title} />
        <Container style={{ minHeight: "600px" }} className="mb-5">
          <br></br>
          {this.state.isLoaded && this.state.data && (
            <div
              className="prose"
              dangerouslySetInnerHTML={{ __html: this.state.data.description }}
            ></div>
          )}
        </Container>
      </div>
    );
  }
}
